
    <div class="dropdown login-drop">
        <a class="nav-item nav-link dropdown-toggle" href="#" id="contactLink" data-bs-auto-close="true"
            data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false">
            Contact Us
        </a>

        <div class="dropdown-menu dropdown-menu-end contact-menu">
            <form class="py-2 p-3" [formGroup]="contactForm" (ngSubmit)="contact($event,contactForm)">
                <h5>SEND US AN EMAIL</h5>
                <div class="mb-2">
                    <label for="" class="form-label">Your Email Address</label>
                    <input type="email" class="form-control" formControlName="email">
                    <div class="invalid-feedback d-block"
                        *ngIf="(f['email'].errors?.['required'] || f['email'].errors?.['email']) && (f['email'].dirty || f['email'].touched)">
                        Please fill valid email.
                    </div>
                </div>
                <div class="mb-2">
                    <label for="" class="form-label">Name</label>
                    <input type="text" class="form-control" formControlName="name">
                    <div class="invalid-feedback d-block"
                        *ngIf="f['name'].errors?.['required'] && (f['name'].dirty || f['name'].touched)">
                        Please fill name.
                    </div>
                </div>
                <div class="mb-2">
                    <label for="" class="form-label">Message</label>
                    <textarea type="text" class="form-control" formControlName="message"></textarea>
                    <div class="invalid-feedback d-block"
                        *ngIf="f['message'].errors?.['required'] && (f['message'].dirty || f['message'].touched)">
                        Please fill message.
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-4">
                    <!-- [disabled]="loginForm.invalid" -->
                    <a (click)="contact($event,contactForm)"
                        class="btn btn-sm btn-gold">Submit  <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></a>
                </div>
            </form>

        </div>
    </div>